module.exports = __webpack_public_path__ + "static/media/upgrade-now-img.22d04a77.png";